import { useEffect } from 'react';

/**
 * The equip tutorial (1. 10. 2026): while `on`, `data-tutorial` on <html> turns every red button grey
 * (styles/index.css) except the one marked `data-tutorial-cta`: the banner's Equip, or Equip in the
 * detail of the item the banner leads to. It stays red and alone until the step is done.
 */
export function useTutorialFocus(on: boolean) {
  useEffect(() => {
    if (!on) return;
    document.documentElement.dataset.tutorial = 'equip';
    return () => {
      delete document.documentElement.dataset.tutorial;
    };
  }, [on]);
}
